/* Millimili — assets/low-power-video.js  (perf 2026-09-17 v4.2, Wonder 2.5.0)
 *
 * v2 NEDEN YETMEDI (16 Eyl olcumu, mobil 375px, onbellek atlatilmis, decodedBodySize):
 *   ana sayfa 39,95 MB — bunun 33,77 MB'i video. 28 videonun 28'i de veri indirmis
 *   (readyState 3-4), hepsi 300px kutuda HD-1080p. Buna ragmen hepsi "paused".
 *
 *   Sebep: v2 dogru seyi yapiyordu ama GEC yapiyordu. Liquid markup'a
 *   <video autoplay><source src="....HD-1080p-7.2Mbps-....mp4"> basiyordu; HTML
 *   ayristiricisi bu elemani gorur gormez medya kaynak secim algoritmasini
 *   baslatiyor. Bu dosya "defer" ile, yani ayristirma bittikten SONRA calisiyor.
 *   disarm() autoplay'i siliyor, preload'u 'none' yapiyor, video duruyor —
 *   ama zaten yola cikmis indirme bu iki islemle iptal edilmiyor. Ayrica kalite
 *   dusurme (prepare) yalnizca play() aninda tetiklendigi icin hic calismiyordu:
 *   kaynaklarda data-wt-orig yoktu, 300px kutuda 1080p iniyordu.
 *
 * v3 YAKLASIMI: markup'ta oynatilabilir kaynak HIC OLMASIN.
 *   snippets/wt-lazy-video.liquid, video_tag ciktisindaki src'leri data-wt-src'ye
 *   tasiyor ve <video>'ya data-wt-lazy="1" koyuyor. Ayristirici indirilecek bir
 *   sey bulamadigi icin tek bayt inmiyor. Burasi video gorunur alana girdiginde
 *   kutu boyutuna uygun kademeyi secip kaynagi bagliyor.
 *
 *   Poster markup'ta kaliyor (video_tag image_size) — ilk kare aninda gelir,
 *   kullanici bos kutu gormez.
 *
 * v4 (16 Eyl aksam): POSTER DE GEC. Kablo bayti olcumunde anasayfanin en buyuk
 *   kalemi poster cikti (mobil 3,02 MB, 32 poster; 2,94 MB'i ilk ekranda degil).
 *   wt-lazy-video.liquid posteri data-wt-poster'a tasiyor. Burasi video ekrana
 *   POSTER_MARGIN kadar yaklasinca posteri, ayni bolumdeki GORUNUR (display:none
 *   olmayan) videolarla birlikte baglar — yatay karuselde saga kayan slaytlar
 *   IntersectionObserver'a gorunmez oldugu icin grup halinde baglamak bos kutu
 *   gostermeyi onler. display:none ikizlerin posteri hic inmez.
 *
 * GERIYE DONUK UYUMLULUK: data-wt-lazy tasimayan videolar (henuz yamalanmamis
 * bolumler, uygulama blogu ciktilari) icin v2'nin kapi davranisi aynen korunuyor —
 * autoplay sokulur, preload kapatilir, ekran disinda oynatilmaz. Boylece kismi
 * yamada hicbir bolum bozulmaz.
 */
(() => {
  if (window.__wtVideoGate) return;
  window.__wtVideoGate = true;

  /* Shopify'in CDN'de hazir tuttugu kademeler (yeniden encode GEREKMEZ).
   * mp4 adlandirmasi tire ayracli: ....HD-1080p-7.2Mbps-92163947.mp4        */
  const R1080 = '.HD-1080p-7.2Mbps-';
  const R720  = '.HD-720p-4.5Mbps-';
  // R480 bilerek kullanilmiyor — bkz. targetRendition aciklamasi.
  const ANY_REND = /\.(?:HD-1080p-7\.2Mbps|HD-720p-4\.5Mbps|SD-480p-1\.5Mbps)-/;
  /* v4.2 (17 Eyl): 300 -> 120. Masaustunde reels bandi ilk ekranin 180px altinda
   * duruyordu; 300px pay yuzunden kaydirma yapilmadan 7 video baglaniyordu (bir
   * olcumde 7,1 MB). 120px'te bant ancak kullanici kaydirmaya baslayinca baglanir. */
  const MARGIN = 120; // gorunmeden biraz once bagla ki poster'dan videoya gecis puruzsuz olsun
  const POSTER_MARGIN = 1200; // poster videodan cok once gelsin: kaydirirken bos kutu gorulmesin

  const bound    = new WeakSet(); // kaynagi baglandi
  const gated    = new WeakSet(); // eski usul kapiya baglandi (lazy olmayanlar)
  const visible  = new WeakSet();
  const wantPlay = new WeakSet();
  const userPaused = new WeakSet();
  const ourPause = new WeakSet();
  const nativePlay = new WeakMap();

  function boxWidth(video) {
    let w = video.getBoundingClientRect().width || video.clientWidth || 0;
    let el = video.parentElement;
    for (let i = 0; i < 4 && el && !w; i++, el = el.parentElement) {
      w = el.getBoundingClientRect().width || 0;
    }
    return w;
  }

  /* Kademe secimi CIHAZ PIKSELINE gore, DPR 2'de kapali.
   * 3x ekranda 390px kutu "1170 cihaz pikseli" ister ama videoda 2x'ten sonrasi
   * gorunmez: sabit maliyet, sifir fayda.
   * data-wt-quality="full" -> PDP galerisi istisnasi, kutuya bakmadan 1080p.   */
  function targetRendition(video) {
    if (video.dataset.wtQuality === 'full') return R1080;
    const w = boxWidth(video);
    if (!w) return R1080; // olculemedi (karusel slaydi henuz 0 genislikte olabilir): kaliteden yana

    /* 16 Eyl duzeltmesi — 480p TAMAMEN DEVRE DISI. Iki sebep:
     *
     *  1) Gorunur kalite: 300px'lik reels kutusu DPR 2'de 600 cihaz pikseli ister.
     *     Portre 480p kaynak ~480px genisligindedir; 600'e gerilince gozle gorulur
     *     bulaniklasiyor (sahip geri bildirimi + ekran goruntusu, 16 Eyl).
     *
     *  2) OLCUM GUVENILMEZ. Baglama ani slider yerlesiminden once gelebiliyor:
     *     ayni koside mm_newin/mm_best kartlari 134px, mm_multicol 49px olculdu —
     *     bunlar gercek boyutlar degil, henuz acilmamis slayt kutulari. Kademe
     *     baglanma aninda secilip kilitlendigi icin yanlis olcum kalici dusuk
     *     kalite demek. Taban 720p olunca bu tuzak tamamen kapaniyor.
     *
     * Bayt maliyeti kabul edilebilir: artik yalnizca GORUNUR videolar iniyor,
     * hepsi degil. Ilk yuklemede inen video sayisi 28 -> 1. */
    /* v4.1 (16 Eyl, sahip karari): esik 700 -> 800. Telefonda tam genislik video
     * 375px x DPR2 = 750 cihaz pikseli istiyordu ve 700'u gectigi icin hero
     * videosu mobilde 1080p (7,1 MB) iniyordu. Artik telefonlar 720p alir;
     * masaustu tam genislik (>= 400px kutu) 1080p'de kalir. */
    const needed = w * Math.min(window.devicePixelRatio || 1, 2);
    return needed > 800 ? R1080 : R720;
  }

  function inViewport(video) {
    const r = video.getBoundingClientRect();
    if (!r.width || !r.height) return false; // 0x0 gizli ikiz: asla oynatma
    const vh = window.innerHeight || document.documentElement.clientHeight || 0;
    const vw = window.innerWidth || document.documentElement.clientWidth || 0;
    return r.bottom > -MARGIN && r.top < vh + MARGIN
        && r.right > -MARGIN && r.left < vw + MARGIN;
  }

  /* ---------- v4: poster ---------- */

  function bindPoster(video) {
    const p = video.getAttribute('data-wt-poster');
    if (!p) return;
    video.setAttribute('poster', p);
    video.removeAttribute('data-wt-poster');
  }

  function bindPosterGroup(video) {
    bindPoster(video);
    const sec = video.closest('.shopify-section') || video.parentElement;
    if (!sec) return;
    sec.querySelectorAll('video[data-wt-poster]').forEach((v) => {
      if (v.getClientRects().length) bindPoster(v); // display:none olanlar atlanir
    });
  }

  const posterObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          bindPosterGroup(e.target);
          posterObserver.unobserve(e.target);
        }
      }, { rootMargin: POSTER_MARGIN + 'px 0px' })
    : null;

  /* ---------- v3 cekirdegi: gorununce kaynagi bagla ---------- */

  function bind(video) {
    if (bound.has(video)) return;
    bound.add(video);
    bindPoster(video); // gorunur hale gelen eski display:none video: posteri simdi gelsin

    const target = targetRendition(video);
    const retarget = (url) => (ANY_REND.test(url) ? url.replace(ANY_REND, target) : url);

    let any = false;

    // <source data-wt-src> -> <source src>
    video.querySelectorAll('source[data-wt-src]').forEach((s) => {
      const raw = s.getAttribute('data-wt-src') || '';
      if (!raw) return;
      // HLS'i atiyoruz: uyarlanabilir akis hizli baglantida 1080p'ye tirmaniyor,
      // kart boyutunda gereksiz. Tek sabit mp4 ongorulebilir bayt demek.
      if (/\.m3u8(\?|$)/.test(raw)) { s.remove(); return; }
      s.dataset.wtOrig = raw;
      s.setAttribute('src', retarget(raw));
      s.removeAttribute('data-wt-src');
      any = true;
    });

    // <video data-wt-src> -> <video src>
    const own = video.getAttribute('data-wt-src');
    if (own) {
      video.dataset.wtOrig = own;
      video.setAttribute('src', retarget(own));
      video.removeAttribute('data-wt-src');
      any = true;
    }

    if (!any) return;
    video.preload = 'auto';
    video.load();
  }

  /* Hedef kademe CDN'de yoksa (kaynak video zaten kucukse) orijinale don. */
  function guardFallback(video) {
    video.addEventListener('error', (e) => {
      const el = e.target;
      const orig = el && el.dataset ? el.dataset.wtOrig : null;
      if (!orig) return;
      el.setAttribute('src', orig);
      delete el.dataset.wtOrig;
      video.load();
      if (wantPlay.has(video) && !userPaused.has(video) && visible.has(video)) start(video);
    }, true); // <source> hatalari bubble etmez -> capture
  }

  function start(video) {
    wantPlay.delete(video);
    bind(video);
    const fn = nativePlay.get(video) || video.play;
    const p = fn.call(video);
    if (p && typeof p.catch === 'function') p.catch(() => {}); // otomatik oynatma reddi sessiz
    return p;
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        for (const e of entries) {
          const v = e.target;
          /* v4.2: IntersectionObserver kaydi slider yerlesiminden ONCE hesaplanmis
           * olabiliyor (17 Eyl olcumu: masaustunde ekranin 340-750px sagindaki
           * slaytlar "gorunur" gelip baglandi). Guncel geometri gorunur alanda
           * degilse baglama; gercekten girince gozlemci yeniden bildirir. */
          if (e.isIntersecting && !inViewport(v)) continue;
          if (e.isIntersecting) {
            visible.add(v);
            bind(v); // gorunur: kaynagi bagla (oynatma istenmese bile poster->video hazir olsun)
            if (wantPlay.has(v) && !userPaused.has(v)) start(v);
          } else {
            visible.delete(v);
            if (!v.paused) {
              ourPause.add(v);
              v.pause();
              wantPlay.add(v); // geri gelince devam etsin
            }
          }
        }
      }, { rootMargin: MARGIN + 'px 0px' })
    : null;

  /* ---------- lazy videolar ---------- */

  function attachLazy(video) {
    if (gated.has(video)) return;
    gated.add(video);
    guardFallback(video);
    nativePlay.set(video, video.play);

    // Baska bir script gorunmeden play() cagirirsa: istegi kaydet, indirme baslatma.
    video.play = function () {
      if (!visible.has(video) && !inViewport(video)) {
        wantPlay.add(video);
        return Promise.resolve();
      }
      visible.add(video);
      return start(video) || Promise.resolve();
    };

    video.addEventListener('pause', () => {
      if (ourPause.has(video)) ourPause.delete(video);
      else userPaused.add(video);
    });
    video.addEventListener('play', () => userPaused.delete(video));

    if (video.dataset.wtAutoplay === '1') wantPlay.add(video);

    if (video.hasAttribute('data-wt-poster')) {
      if (posterObserver) posterObserver.observe(video);
      else bindPoster(video);
    }

    if (observer) observer.observe(video);
    else if (inViewport(video)) start(video);
  }

  /* ---------- yamalanmamis videolar: v2 kapisi aynen ---------- */

  function disarm(video) {
    if (video.hasAttribute('autoplay')) {
      video.removeAttribute('autoplay');
      video.autoplay = false;
    }
    if (video.preload !== 'none') video.preload = 'none';
  }

  function attachLegacy(video) {
    if (gated.has(video)) return;
    gated.add(video);

    const wasAutoplay = video.hasAttribute('autoplay') || video.autoplay === true
      || video.dataset.wtAutoplay === 'true';
    disarm(video);
    guardFallback(video);
    nativePlay.set(video, video.play);

    video.play = function () {
      if (!visible.has(video) && !inViewport(video)) {
        disarm(video);
        wantPlay.add(video);
        return Promise.resolve();
      }
      visible.add(video);
      const fn = nativePlay.get(video);
      const p = fn.call(video);
      if (p && typeof p.catch === 'function') p.catch(() => {});
      return p || Promise.resolve();
    };

    video.addEventListener('pause', () => {
      if (ourPause.has(video)) ourPause.delete(video);
      else userPaused.add(video);
    });
    video.addEventListener('play', () => userPaused.delete(video));

    if (!wasAutoplay) return;
    wantPlay.add(video);
    if (observer) observer.observe(video);
    else if (inViewport(video)) video.play();
  }

  function handle(video) {
    if (!video) return;
    if (video.dataset.wtLazy === '1') attachLazy(video);
    else attachLegacy(video);
  }

  const sweep = (root) => (root || document).querySelectorAll('video').forEach((v) => {
    handle(v);
    // Yamalanmamis videolarda tema script'leri preload'u geri acabiliyor (10 Eyl olcumu).
    if (v.dataset.wtLazy !== '1'
        && v.preload !== 'none' && !visible.has(v) && !inViewport(v) && !userPaused.has(v)) {
      disarm(v);
    }
  });

  sweep();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sweep(), { once: true });
  }
  window.addEventListener('load', () => sweep(), { once: true });

  // Slider klonlari, quick-add, bolum yeniden render'i: sonradan gelen videolari yakala.
  if ('MutationObserver' in window) {
    new MutationObserver((muts) => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'VIDEO') handle(n);
          else if (n.querySelectorAll) sweep(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
